export const env = {
  basePath: process.env.REACT_APP_BASE_URL,
  mesCotaRequestPah: process.env.REACT_APP_BASE_MES_COTA,
  apiVersion: 'v2',
  draftBasePath: 'rascunho',
  clientBasePath: 'cliente',
  manageOVBasePath: 'gerir-ov',
  ovDetailBasePath: 'detalhes',
  maintenanceOVBasePath: 'editar-ordem-venda',
  creditByClientIdBasePath: 'CreditoClienteByID',
  commercialStructure: 'estrut-comerc',
  ovDetailedInfo: 'informacoes-adicionais'
}
